import React from "react";

function CategoryListing() {
	return (
		<div>
			<h1>This is CategoryListing</h1>
		</div>
	);
}

export default CategoryListing;
